import coverImageMixin from 'Site/js/mixin/cover.image';
import Geocomplete from 'Location/component/Geocomplete.vue';
import SiteInput from 'Site/component/SiteInput.vue';
import store from 'Site/js/store';
import Vue from 'vue';
import { mapState } from 'vuex';
import Wysiwyg from 'Site/component/Wysiwyg.vue';

/* eslint no-new:0 */
export default function () {
    new Vue({/* eslint no-new:0 */
        el: '#club-create-vue',
        name: 'clubCreate',
        store,
        components: {
            Geocomplete,
            SiteInput,
            Wysiwyg
        },
        computed: mapState(['t']),
        data: {
            coverImage: store.state.config.data.coverUrl.replace('REPLACE', 'bubbles/small.jpg'),
            coverImageName: 'bubbles',
            coverImageMedia: null,
            latitude: '',
            longitude: '',
            ownerText: store.state.config.data.ownerText
        },
        methods: {
            changeCoverImage(coverImage) {
                this.showCoverImageModal = false;
                this.coverImage = coverImage.url;
                if (!coverImage.site) {
                    this.coverImageName = null;
                    this.coverImageMedia = coverImage;
                } else {
                    this.coverImageName = coverImage.name;
                    this.coverImageMedia = null;
                }
            },
            geocomplete({ result }) {
                this.latitude = result.geometry.location.lat();
                this.longitude = result.geometry.location.lng();
            }
        },
        mixins: [coverImageMixin]
    });
}
